import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import { compose } from 'react-recompose';
import ContactsComponent from './contacts';
import changeRepVisitsContactNotes from './changeContactNotesMutation';
import { loadMorePaginationProp, SimpleLoadingComponent } from '../../utils/apollo';

const query = gql`
  query RepVisitsContacts($filter: String!, $first: Int!, $after: String) {
    viewer {
      id
      repVisitsContacts(filter: $filter, first: $first, after: $after) {
          pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              id
              highSchool {
                id
                name
                address {
                  field_hs_elna_address_line1
                  field_hs_elna_state_latest
                  field_hs_elna_city
                  field_hs_eln_zip
                }
                naviance {
                  field_hs_elna_phone
                }
                repVisitsAccount {
                  id
                  primaryContact {
                    id
                    mail
                    field_first_name
                    field_last_name
                    field_full_name
                    field_job_position
                    field_profile_picture_file_url
                  }
                }
              }
              notes
            }
          }
        }
    }
  }
`;

const graphqlData = compose(
  graphql(query, {
    options: ({ filter }) => ({
      variables: {
        first: 25,
        filter,
      },
    }),
    props: loadMorePaginationProp(query),
  }),
  graphql(changeRepVisitsContactNotes, { name: 'changeRepVisitsContactNotes' }),
);

export default SimpleLoadingComponent(graphqlData)(ContactsComponent);
